import { VoucherLog, VoucherLogMetadata } from '~/services/PromoService';

export type VoucherLogDisplayMode = 'discount-only' | 'provide-credit-only' | 'mixed';

type MetadataWithRewardKind = VoucherLogMetadata & {
  voucher_reward_kind?: string;
};

/**
 * Credit-on-purchase logs carry reward kind and/or credit lifecycle fields on metadata.
 * When kind is absent, credit timestamps are treated as provide-credit; otherwise defaults
 * to discount-style application logs.
 */
export function isVoucherLogProvideCredit(log: VoucherLog): boolean {
  const meta = log.metadata as MetadataWithRewardKind | undefined;
  if (!meta) return false;

  const kind = meta.voucherRewardKind ?? meta.rewardKind ?? meta.voucher_reward_kind;
  if (kind === 'provide_credit') return true;
  if (kind === 'discount') return false;

  return Boolean(meta.creditGrantedAt || meta.creditPayoutAt || meta.creditPayoutLastCheckedAt);
}

/** Derives table mode from the logs currently shown (current page / loaded set). */
export function getVoucherLogDisplayMode(logs: ReadonlyArray<VoucherLog>): VoucherLogDisplayMode {
  if (!logs.length) return 'discount-only';

  let credit = 0;
  let discount = 0;
  for (const log of logs) {
    if (isVoucherLogProvideCredit(log)) credit += 1;
    else discount += 1;
  }
  if (credit === 0) return 'discount-only';
  if (discount === 0) return 'provide-credit-only';
  return 'mixed';
}
